export const environment = {
  production: true,

  API_URL_WITHOUT_PORT: "https://admin.chatstasydev.biz",
  API_URL: "https://adminapi.chatstasydev.biz",
  API_URL_BUSINESS_ADMIN: "https://api.chatstasydev.biz",
  IMAGE_BASE_URL: "https://adminapi.chatstasydev.biz/api/anonymous/cdn/",
  IMAGE_BASE_URL_BUSINESS_ADMIN: "https://api.chatstasydev.biz/api/anonymous/cdn/",
  CHAT_SOCKET_URL: "https://api.chatstasydev.biz",


  // API_URL_WITHOUT_PORT: "http://chatstasy.biz",
  // API_URL: "http://localhost:8019",
  // API_URL_BUSINESS_ADMIN: "http://localhost:8020",
  // IMAGE_BASE_URL: "http://localhost:8019/api/anonymous/cdn/",
  // IMAGE_BASE_URL_BUSINESS_ADMIN: "http://localhost:8020/api/anonymous/cdn/",
  // CHAT_SOCKET_URL: "http://localhost:8021",

  FRESHDESK_URL: "https://chatstasy.freshdesk.com",
  FRESHDESK_API_KEY: "1Q6zC8iEUlckfSasIRyB",
  // firebaseConfig: { // old firebase config
  //   apiKey: "AIzaSyDNX5alPwfqYnRtxzmF1d1nEHuQiqBBlxQ",
  //   authDomain: "chatstasy-52116.firebaseapp.com",
  //   projectId: "chatstasy-52116",
  //   storageBucket: "chatstasy-52116.appspot.com",
  //   messagingSenderId: "571243245038",
  //   appId: "1:571243245038:web:d03326223b71d589e672ff",
  //   databaseURL: 'https://chatstasy-52116.firebaseio.com/'
  // }
  firebaseConfig:{
    apiKey: "AIzaSyAwQyXO9mVHlMd9zTlVzpzAomV9iXjP-g0",
    authDomain: "chatstasy-biztest.firebaseapp.com",
    projectId: "chatstasy-biztest",
    storageBucket: "chatstasy-biztest.appspot.com",
    messagingSenderId: "474166342732",
    appId: "1:474166342732:web:f2dce8e58ef87f978270e9",
    measurementId: "G-ZSHS5D6HHN",
    databaseURL: 'https://chatstasy-biztest-default-rtdb.firebaseio.com/'
  }
};
